module.exports = __webpack_public_path__ + "img/car5.799c6fb8.png";